import React, {useRef, useEffect, useState} from "react";
import Header from "../components/Header";
import mapboxgl from 'mapbox-gl'
import {useNavigate, useParams, useSearchParams} from "react-router-dom";

import 'mapbox-gl/dist/mapbox-gl.css';
import Footer from "../components/Footer";
import Search from "../components/Search";
import {useModal} from "../components/ModalContext";
import Alert from "react-bootstrap/Alert";
import Button from "react-bootstrap/Button";
import Spinner from "../components/Spinner/Spinner";
import AreaComponent from "../components/Card/Area/AreaComponent";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Form from "react-bootstrap/Form";


function PurchaseTicket() {
    const navigate = useNavigate();

    const {id} = useParams(); // Ottiene il parametro dalla URL (es. 123)
    const [searchParams] = useSearchParams();
    const [loading, setLoading] = useState(true);
    const [ticket, setTicket] = useState();

    const [dateStart, setDateStart] = useState(new Date());
    const [dateEnd, setDateEnd] = useState(new Date());

    const advantage = searchParams.get("advantage"); // Ottiene il valore della query string
    console.log("id")
    console.log(id)

    useEffect(() => {
        if (typeof id === "undefined")
            return;
        fetch(global.baseUrl + "app/ticket/area/info", {
            method: 'POST',
            credentials: 'include',
            body: global.getFormData(
                {id: id}
            )
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Errore nella richiesta");
                }
                return response.json();
            })
            .then((data) => {
                setTicket(data);
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
            });
    }, [id]);

    const mapRef = useRef()
    const mapContainerRef = useRef()


    let content = [];


    // useEffect(() => {
    //
    //     mapboxgl.accessToken = 'pk.eyJ1IjoiZ2VvdGlja2V0c3JsIiwiYSI6ImNsenFvcmh1dzF0bDgyanFyd3lhaGhtNWMifQ.Lt-gOko0rO-VuTBu3kKD1w'
    //     mapRef.current = new mapboxgl.Map({
    //         container: mapContainerRef.current,
    //         center: [12.2558141, 41.9097306],
    //         zoom: 5
    //     });
    //
    //     return () => {
    //         mapRef.current.remove()
    //     }
    // }, [])

    let getContent = () => {
        if (loading)
            return <Spinner size={"l"}/>;
        if (typeof id === "undefined") {
            return <><Alert key={"danger"} variant={"danger"}>
                Nessun ticket trovato <Button variant={"light"} onClick={() => navigate("/home")}>Torna in home</Button>
            </Alert></>


        } else {

            let content = [];
            content.push(<AreaComponent area={ticket.area}/>)


            content.push(<>
                <div style={{backgroundColor:"#fafafa", borderRadius: 8, padding: 8}}>
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>Data inizio</Form.Label>
                        <DatePicker
                            selected={dateStart}
                            onChange={(date) => setDateStart(date)}
                            dateFormat="dd/MM/yyyy"
                            className="form-control"
                        />

                    </Form.Group>

                    <DatePicker
                        selected={dateEnd}
                        onChange={(date) => setDateEnd(date)}
                        dateFormat="dd/MM/yyyy"
                        className="border p-2 rounded-lg shadow-md"
                    />
                </div>
            </>)

            return content;

        }


    }

    return (
        <div style={{backgroundColor: "#212121"}}>
            <Header/>
            <Search/>
            <div className="container" style={{paddingTop: 86, minHeight: "100vh"}}>
                {getContent()}

            </div>
            <Footer/>
        </div>
    );
}

export default PurchaseTicket;